import type { To } from 'react-router';

import type { MayBe } from 'types/common';

type NavigateOptions = {
  replace?: boolean;
  state?: unknown;
};

type Navigable = {
  navigate: {
    (delta: number): unknown;
    (to: To, options?: NavigateOptions): unknown;
  };
};

let routerInstance: MayBe<Navigable>;

export const registerRouter = (router: Navigable): void => {
  routerInstance = router;
};

export const navigate = (to: To | number, options?: NavigateOptions): void => {
  if (!routerInstance) {
    throw new Error('navigate() called before registerRouter() — call it during app bootstrap.');
  }

  if (typeof to === 'number') {
    routerInstance.navigate(to);
    return;
  }

  routerInstance.navigate(to, options);
};
